import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import { PAGE_PRODUCT_TYPE } from "@constants"
import { pageProductType } from "@signals"

const OPTIONS = [
    { label: "Fragrances", value: PAGE_PRODUCT_TYPE.FRAGRANCES },
    { label: "Fragrances Mix", value: PAGE_PRODUCT_TYPE.MIX },
    { label: "Makeup", value: PAGE_PRODUCT_TYPE.MAKE_UP },
    { label: "Cosmetic", value: PAGE_PRODUCT_TYPE.COSMETIC }
]

export default function PageProductTypeSelect({ ...props }) {
    return <SelectSeeker
        multiple
        isClearable
        options={OPTIONS}
        label="Page Product Types"
        placeholder="Select a page product type"
        value={pageProductType.value}
        onChange={e => pageProductType.value = e.target.value}
        {...props}
    />
}